import React, { useState } from "react";
import Text from "../../../common/typography/text.js";
import { formatCurrency, formatWholeCurrency } from "../aabiFormatters";
import { formatCompactCurrency } from "../aabiViewModel";
import "./../AABI.css";

// A currency figure shown in compact form ($284K) that toggles to the exact
// whole-dollar value ($284,311) on click. Every compact amount rendered as page
// text should go through this component so the behaviour stays global. Chart
// canvas labels can't host it and keep using formatCompactCurrency directly.
//
// `staticValue` renders plain text instead of a toggle button, with the exact
// amount in the tooltip. It is used inside a link (a KPI tile), where a nested
// button would be invalid interactive content.
const CompactCurrency = ({ value, prefix = "", staticValue = false, ...textProps }) => {
  const [expanded, setExpanded] = useState(false);
  const text = expanded ? formatWholeCurrency(value) : formatCompactCurrency(value);

  if (staticValue) {
    return (
      <span className="aabi-compact-currency-static" title={formatCurrency(value)}>
        <Text {...textProps}>{`${prefix}${formatCompactCurrency(value)}`}</Text>
      </span>
    );
  }

  return (
    <button
      type="button"
      className="aabi-compact-currency"
      onClick={(event) => {
        // Often rendered inside a row link; toggling must not navigate.
        event.preventDefault();
        event.stopPropagation();
        setExpanded((prev) => !prev);
      }}
      aria-pressed={expanded}
      title={expanded ? "Show short form" : "Show full amount"}
    >
      <Text {...textProps}>{`${prefix}${text}`}</Text>
    </button>
  );
};

export default CompactCurrency;
